import type { FC } from "react";
import { ChevronRight, CheckCircle, Star } from "lucide-react";
import type { ProgramInterface } from "../../types/program.interface";
import { BASE_URL } from "../../services/constants";

type Props = {
  program: ProgramInterface;
};

const ProgramCard: FC<Props> = ({ program }) => {
  const image = `https://image.beholos.com/600x500/filters:quality(90)${program.cardImage}`
  return (
    <div className="text-center mb-5">
      <a
        href={`${BASE_URL}/programas/${program.slug || ""}`}
        className="relative block h-[400px] bg-cover bg-center overflow-hidden"
        style={{
          backgroundImage: `url('${image}')`
        }}
      >
        <div className="absolute inset-0 bg-black/20 text-white p-4 flex flex-col justify-between text-left">
          <div className="flex justify-between items-start mb-1">
            <div className="flex-1">
              {program.inProgress && (
                <span className="text-xs font-semibold uppercase bg-black rounded-full py-1 px-3">En progreso</span>
              )}
              {program.programCompleted && (
                <span className="flex items-center text-xs font-semibold text-green-400 bg-black rounded-full py-1 px-2">
                  <CheckCircle className="w-8 h-8 mr-2" />
                  Completaste este programa
                </span>
              )}
            </div>
            <div className="text-sm text-right">
              {program.classLengthShort}/{program.days} días
              {program.ratingCount ? (
                <>
                  <br />
                  <div className="inline-flex items-center">
                    <Star className="w-4 h-4 text-yellow-400 mr-1" />
                    {(program.rating! + 1).toFixed(1)}
                    <span className="mx-2">|</span>
                    {program.ratingCount}{" "}
                    {program.ratingCount > 1 ? "opiniones" : "opinión"}
                  </div>
                </>
              ) : null}
            </div>
          </div>

          <div>
            <div className="font-bold italic text-base mb-1">{program.name}</div>
            <div className="text-sm mb-2">{program.shortDescription}</div>
            <div className="text-holos text-sm inline-flex items-center">
              Ver más
              <ChevronRight className="w-4 h-4 ml-1" />
            </div>
          </div>
        </div>
      </a>
    </div>
  );
};

export default ProgramCard;
